import type { ConditionType, HeliosNotificationConditionsBaseState, HeliosNotificationConditionsState } from '../index';

export const setConditions = (
  state: HeliosNotificationConditionsState,
  {
    payload,
  }: {
    payload: {
      data: HeliosNotificationConditionsBaseState | null;
      type: ConditionType;
    };
  }
) => {
  state[payload.type] = payload.data as unknown as HeliosNotificationConditionsState[ConditionType];
};
